import { CHANGE_ALL_PREFERENCES, CHANGE_PREFERENCES, INIT_PREFERENCES } from './actions';

export const initialState = {
    promotional: [],
    account: [],
    thirdParty: []
};

export default (reducerSuffix) => (state = initialState, action) => {
    switch (action.type) {
        case INIT_PREFERENCES:
        case INIT_PREFERENCES + reducerSuffix: {
            return {
                ...state,
                ...action.payload
            };
        }

        case CHANGE_PREFERENCES:
        case CHANGE_PREFERENCES + reducerSuffix: {
            const {
                checked,
                type,
                index
            } = action.payload;

            return {
                ...state,
                [type]: state[type].map((item, i) => i === index ? { ...item, preference: checked } : item)
            };
        }

        case CHANGE_ALL_PREFERENCES:
        case CHANGE_ALL_PREFERENCES + reducerSuffix: {
            const {
                checked,
                type
            } = action.payload;

            return {
                ...state,
                [type]: state[type].map(item => ({ ...item, preference: checked }))
            };
        }

        default:
            return state;
    }
};
